import * as React from 'react';

import { Link } from '~/UI/Button';

import { ERP_HELP_URL } from '~/ERP/utils/url';

const ERPHelpLink = ({ className, children }: { className: string; children?: React.ReactNode }) => {
	return (
		<Link className={className} to={ERP_HELP_URL}>
			About IRP calculation{children && '\u00A0'}
			{children || null}
		</Link>
	);
};

export default React.memo(ERPHelpLink);
